import AOS from 'aos';
import 'aos/dist/aos.css';

export default function () {
  const widgetName = 'eventCards';
  const widgetOpts = eventCardsOpts;

  let windowSize = $(window).width();
  let breakpoint = 800;

  AOS.init({
    anchorPlacement: 'bottom-bottom',
    animatedClassName: 'aos-animate',
    initClassName: 'aos-init',
  });

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      console.log(data);

      $(`#${widgetName} .card-widget-item`).each(function (x) {
        $(this).find('.image-container').append('<div class="overlay"></div>');
        $(this).find('.overlay').append('<div class="overlay-border"></div>');
        $(this).find('.buyNowButton').addClass('button');
        $(this).find('.moreButton').addClass('button');
        $(this).removeAttr('target');

        $(this).attr({
          'data-aos': 'flip-up',
          'data-aos-easing': 'ease-in-out',
          'data-aos-duration': '500',
          'data-aos-delay': (x + 1) * 300,
          'data-aos-once': 'true',
          'data-aos-offset': '200',
        });

        if (data.items[x].URL == null && data.items[x].PurchaseURL == null) {
          $(this).removeAttr('href');
          if (windowSize > breakpoint) {
            $(this).addClass('void-link');
          }
        } else if (data.items[x].URL == null && data.items[x].PurchaseURL != null) {
          $(this).attr('href', data.items[x].PurchaseURL);
        }
      });
    },
    link: windowSize < breakpoint ? ['all'] : [''],
    maxItemsVisible: 8,
    itemsPerPanel: 8,
    hasImages: true,
    lazyLoadImages: true,
    textOverImage: true,
    imageIsBackground: true,
    showDescription: false,
    buyNowButton: {
      visible: true,
      text: 'BUY NOW',
    },
    moreButton: {
      visible: true,
      text: 'More',
    },
    scriptPath: widgetOpts.scriptPath,
  });
}
